import React from 'react';
import { COMPANY } from '../mock';

const WhatsAppButton = () => {
  const href = `https://wa.me/${COMPANY.whatsapp}?text=${encodeURIComponent(COMPANY.whatsappMsg)}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] shadow-lg ea-whatsapp-pulse transition-transform hover:scale-110"
    >
      <svg viewBox="0 0 32 32" className="h-8 w-8 fill-white">
        <path d="M16.003 3C9.38 3 4 8.38 4 15.003c0 2.114.553 4.177 1.605 6L4 29l8.2-2.146a11.94 11.94 0 0 0 3.803.62h.003C22.626 27.474 28 22.094 28 15.47 28 8.847 22.626 3 16.003 3zm0 21.74h-.002a9.9 9.9 0 0 1-3.51-.64l-.252-.1-4.866 1.272 1.298-4.74-.165-.26a9.86 9.86 0 0 1-1.512-5.27c0-5.456 4.44-9.896 9.9-9.896 2.644 0 5.13 1.03 7 2.9a9.83 9.83 0 0 1 2.9 6.998c0 5.456-4.44 9.896-9.79 9.896zm5.43-7.41c-.297-.15-1.758-.868-2.03-.967-.272-.1-.47-.15-.668.148-.198.297-.767.967-.94 1.165-.173.198-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.76-1.653-2.057-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.52.149-.174.198-.298.297-.496.099-.198.05-.372-.025-.52-.075-.15-.668-1.612-.916-2.207-.241-.58-.486-.5-.668-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479s1.065 2.875 1.213 3.073c.149.198 2.095 3.2 5.076 4.487.71.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.247-.694.247-1.29.173-1.413-.074-.124-.272-.198-.57-.347z"/>
      </svg>
    </a>
  );
};

export default WhatsAppButton;
